import {
  ActivityIcon,
  SmileEmoji,
  AnimalEmoji,
  FoodEmoji,
  TravelEmoji,
  ObjectsEmoji,
  SymbolsEmoji,
  FlagEmoji,
} from '@quicktools/shared-components/components/core/svgicons';
import categories from '@quicktools/emojis/data/categories';
import { PillsButtons } from '@quicktools/shared-components';

import useStyles from './styles';
import ICategoriesProps from './types';

const svgComponents = {
  'smiles-emoji': <SmileEmoji />,
  'animals-emoji': <AnimalEmoji />,
  'food-emoji': <FoodEmoji />,
  'activity-emoji': <ActivityIcon />,
  'travel-emoji': <TravelEmoji />,
  'objects-emoji': <ObjectsEmoji />,
  'symbols-emoji': <SymbolsEmoji />,
  'flags-emoji': <FlagEmoji />,
};

function CategoryFilter({ heading, onSelectItem, selectedCategory }: ICategoriesProps) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {heading && <div className={classes.heading}>{heading}</div>}

      <PillsButtons
        pills={categories}
        onSelectItem={onSelectItem}
        icons={svgComponents}
        selected={selectedCategory}
        withLink
      />
    </div>
  );
}

export default CategoryFilter;
